import { render, staticRenderFns } from "./NbGtJbxx.vue?vue&type=template&id=3089be9e&scoped=true"
import script from "./NbGtJbxx.vue?vue&type=script&lang=js"
export * from "./NbGtJbxx.vue?vue&type=script&lang=js"
import style0 from "./NbGtJbxx.vue?vue&type=style&index=0&id=3089be9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3089be9e",
  null
  
)

export default component.exports